var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { Emoji } from "emoji-mart";
import { Para } from "@irati/ui/src/Labels";
import Span from "@irati/ui/src/Link/styled/Span";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
var TellMeMore = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: 30px;\n"], ["\n  display: flex;\n  margin-bottom: 30px;\n"])));
var MarginLeft = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 10px;\n"], ["\n  margin-left: 10px;\n"])));
var TellMeMoreSection = /** @class */ (function (_super) {
    __extends(TellMeMoreSection, _super);
    function TellMeMoreSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TellMeMoreSection.prototype.render = function () {
        var _a = this.props, emoji = _a.emoji, title = _a.title, onClick = _a.onClick, formatMessage = _a.formatMessage;
        return (React.createElement(TellMeMore, null,
            React.createElement("div", null,
                React.createElement(Emoji, { emoji: { id: emoji }, size: 14, set: "apple" })),
            React.createElement(MarginLeft, null,
                React.createElement(Para, { large: true }, formatMessage({ id: title })),
                React.createElement(Span, { bold: false, uppercase: false, inBody: true, onClick: function () { return onClick(title); } },
                    React.createElement(FormattedMessage, { id: "medical.myMedical.tellMeMore.text" })))));
    };
    return TellMeMoreSection;
}(PureComponent));
export default injectIntl(TellMeMoreSection);
var templateObject_1, templateObject_2;
